// src/ContactPage.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Kanit:wght@300;400;500;600;700;800;900&family=Space+Mono:wght@400;700&display=swap');
  .jkl-contact * { margin: 0; padding: 0; box-sizing: border-box; }
  .jkl-contact {
    --black:#07070a;--deep:#0a0a0f;--card:#0f0f16;--border:rgba(255,255,255,0.07);
    --gold:#d4a550;--gold-lt:#f0c878;--gold-dim:rgba(212,165,80,0.12);
    --white:#f0ece4;--muted:#8a8a9a;--faint:#2a2a38;--red:#f87171;
    background:var(--black);color:var(--white);font-family:'Kanit',sans-serif;min-height:100vh;overflow-x:hidden;
  }
  .jkl-contact::before{content:'';position:fixed;inset:0;background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.035'/%3E%3C/svg%3E");pointer-events:none;z-index:1000;opacity:0.5;}
  .jkl-c-nav{position:fixed;top:0;left:0;right:0;z-index:200;display:flex;align-items:center;justify-content:space-between;padding:0 48px;height:64px;background:rgba(7,7,10,0.92);backdrop-filter:blur(24px);border-bottom:1px solid var(--border);}
  .jkl-c-nav-logo{display:flex;align-items:center;gap:0;cursor:pointer;}
  .jkl-c-nav-back{font-family:'Space Mono',monospace;font-size:11px;letter-spacing:0.12em;color:var(--muted);text-decoration:none;text-transform:uppercase;transition:color 0.2s;cursor:pointer;}
  .jkl-c-nav-back:hover{color:var(--gold);}
  .jkl-c-wrap{max-width:640px;margin:0 auto;padding:120px 48px 80px;}
  .jkl-c-eyebrow{font-family:'Space Mono',monospace;font-size:11px;letter-spacing:0.25em;text-transform:uppercase;color:var(--gold);margin-bottom:16px;}
  .jkl-c-title{font-family:'Kanit',sans-serif;font-size:clamp(40px,6vw,72px);font-weight:900;line-height:0.95;letter-spacing:-0.02em;text-transform:uppercase;margin-bottom:20px;}
  .jkl-c-title .dim{color:var(--faint);}
  .jkl-c-sub{font-family:'Kanit',sans-serif;font-size:17px;font-weight:300;color:var(--muted);line-height:1.7;margin-bottom:56px;}
  .jkl-c-sub strong{color:var(--white);font-weight:500;}
  .jkl-c-form{display:flex;flex-direction:column;gap:20px;}
  .jkl-c-field{display:flex;flex-direction:column;gap:8px;}
  .jkl-c-label{font-family:'Space Mono',monospace;font-size:10px;letter-spacing:0.18em;text-transform:uppercase;color:var(--muted);}
  .jkl-c-input{background:rgba(255,255,255,0.04);border:1px solid var(--border);border-radius:8px;color:var(--white);font-family:'Kanit',sans-serif;font-size:15px;font-weight:400;padding:14px 18px;outline:none;transition:border-color 0.2s;width:100%;}
  .jkl-c-input:focus{border-color:rgba(212,165,80,0.5);}
  .jkl-c-input::placeholder{color:var(--faint);}
  .jkl-c-input.error{border-color:rgba(248,113,113,0.5);}
  .jkl-c-textarea{resize:vertical;min-height:140px;font-family:'Kanit',sans-serif;}
  .jkl-c-selector{display:grid;grid-template-columns:1fr 1fr;gap:12px;}
  .jkl-c-sel-btn{background:rgba(255,255,255,0.03);border:1px solid var(--border);border-radius:8px;color:var(--muted);font-family:'Kanit',sans-serif;font-size:14px;font-weight:600;padding:14px;cursor:pointer;transition:all 0.2s;text-align:center;}
  .jkl-c-sel-btn:hover{border-color:rgba(212,165,80,0.3);color:var(--white);}
  .jkl-c-sel-btn.active{background:var(--gold-dim);border-color:rgba(212,165,80,0.5);color:var(--gold);}
  .jkl-c-btn{background:var(--gold);border:none;border-radius:6px;color:var(--black);cursor:pointer;font-family:'Kanit',sans-serif;font-size:15px;font-weight:800;letter-spacing:0.1em;padding:16px 40px;text-transform:uppercase;transition:all 0.2s;width:100%;margin-top:8px;}
  .jkl-c-btn:hover{background:var(--gold-lt);transform:translateY(-2px);box-shadow:0 8px 30px rgba(212,165,80,0.25);}
  .jkl-c-btn:disabled{opacity:0.5;cursor:not-allowed;transform:none;}
  .jkl-c-error{font-family:'Kanit',sans-serif;font-size:13px;color:var(--red);margin-top:4px;}
  .jkl-c-success{background:rgba(74,222,128,0.08);border:1px solid rgba(74,222,128,0.25);border-radius:12px;padding:40px 32px;text-align:center;}
  .jkl-c-success-icon{font-size:40px;margin-bottom:16px;}
  .jkl-c-success h3{font-family:'Kanit',sans-serif;font-size:24px;font-weight:800;color:#4ade80;margin-bottom:12px;}
  .jkl-c-success p{font-family:'Kanit',sans-serif;font-size:15px;font-weight:300;color:var(--muted);line-height:1.7;}
  .jkl-c-footer{margin-top:80px;padding-top:32px;border-top:1px solid var(--border);display:flex;justify-content:space-between;align-items:center;}
  .jkl-c-footer-copy{font-family:'Space Mono',monospace;font-size:10px;color:var(--faint);letter-spacing:0.08em;}
  @media(max-width:768px){.jkl-c-nav{padding:0 24px;}.jkl-c-wrap{padding:100px 24px 60px;}.jkl-c-selector{grid-template-columns:1fr;}}
`;

const SVG_LOGO = (
  <svg width="80" height="28" viewBox="0 0 80 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" width="22" height="22" rx="3.5" fill="rgba(212,165,80,0.12)" stroke="rgba(212,165,80,0.5)" strokeWidth="1"/>
    <text x="11" y="15.5" textAnchor="middle" fill="#d4a550" fontSize="13" fontWeight="700" fontFamily="Kanit,Inter,sans-serif">J</text>
    <rect x="29" y="0" width="22" height="22" rx="3.5" fill="rgba(212,165,80,0.12)" stroke="rgba(212,165,80,0.5)" strokeWidth="1"/>
    <text x="40" y="15.5" textAnchor="middle" fill="#d4a550" fontSize="13" fontWeight="700" fontFamily="Kanit,Inter,sans-serif">K</text>
    <rect x="58" y="0" width="22" height="22" rx="3.5" fill="rgba(212,165,80,0.12)" stroke="rgba(212,165,80,0.5)" strokeWidth="1"/>
    <text x="69" y="15.5" textAnchor="middle" fill="#d4a550" fontSize="13" fontWeight="700" fontFamily="Kanit,Inter,sans-serif">L</text>
  </svg>
);

export default function ContactPage({ onBack }) {
  const { t } = useTranslation();
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [tipo, setTipo] = useState('');
  const [azienda, setAzienda] = useState('');
  const [messaggio, setMessaggio] = useState('');
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const validate = () => {
    const e = {};
    if (!nome.trim()) e.nome = t('contact.err_required');
    if (!email.trim()) e.email = t('contact.err_required');
    else if (!/^[^@]+@[^@]+\.[^@]+$/.test(email)) e.email = t('contact.err_email_invalid');
    if (!tipo) e.tipo = t('contact.err_type');
    if (tipo === 'produzione' && !azienda.trim()) e.azienda = t('contact.err_required');
    if (!messaggio.trim()) e.messaggio = t('contact.err_required');
    return e;
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setSending(true); setErrors({});
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nome, email, tipo, azienda, messaggio }),
      });
      if (res.ok) { setSent(true); }
      else { const d = await res.json(); setErrors({ general: d.error || t('contact.err_network') }); }
    } catch { setErrors({ general: t('contact.err_network') }); }
    finally { setSending(false); }
  };

  return (
    <div className="jkl-contact">
      <style>{STYLES}</style>
      <nav className="jkl-c-nav">
        <div className="jkl-c-nav-logo">{SVG_LOGO}</div>
        <span className="jkl-c-nav-back" onClick={onBack}>{t('contact.back')}</span>
      </nav>
      <div className="jkl-c-wrap">
        <p className="jkl-c-eyebrow">{t('contact.eyebrow')}</p>
        <h1 className="jkl-c-title">{t('contact.title1')}<br/><span className="dim">{t('contact.title2')}</span></h1>
        <p className="jkl-c-sub">{t('contact.sub')} <strong>{t('contact.sub_strong')}</strong></p>

        {sent ? (
          <div className="jkl-c-success">
            <div className="jkl-c-success-icon">✓</div>
            <h3>{t('contact.success_title')}</h3>
            <p>{t('contact.success_pre')} <strong style={{color:'#f0ece4'}}>{email}</strong> {t('contact.success_post')}</p>
          </div>
        ) : (
          <div className="jkl-c-form">
            <div className="jkl-c-field">
              <label className="jkl-c-label">{t('contact.label_name')}</label>
              <input className={"jkl-c-input"+(errors.nome?' error':'')} value={nome} onChange={e=>setNome(e.target.value)} placeholder={t('contact.ph_name')} />
              {errors.nome && <span className="jkl-c-error">{errors.nome}</span>}
            </div>
            <div className="jkl-c-field">
              <label className="jkl-c-label">{t('contact.label_email')}</label>
              <input className={"jkl-c-input"+(errors.email?' error':'')} type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder={t('contact.ph_email')} />
              {errors.email && <span className="jkl-c-error">{errors.email}</span>}
            </div>
            <div className="jkl-c-field">
              <label className="jkl-c-label">{t('contact.label_type')}</label>
              <div className="jkl-c-selector">
                <button className={"jkl-c-sel-btn"+(tipo==='freelance'?' active':'')} onClick={()=>{setTipo('freelance');setAzienda('');}}>{t('contact.type_freelance')}</button>
                <button className={"jkl-c-sel-btn"+(tipo==='produzione'?' active':'')} onClick={()=>setTipo('produzione')}>{t('contact.type_production')}</button>
              </div>
              {errors.tipo && <span className="jkl-c-error">{errors.tipo}</span>}
            </div>
            {tipo === 'produzione' && (
              <div className="jkl-c-field">
                <label className="jkl-c-label">{t('contact.label_company')}</label>
                <input className={"jkl-c-input"+(errors.azienda?' error':'')} value={azienda} onChange={e=>setAzienda(e.target.value)} placeholder={t('contact.ph_company')} />
                {errors.azienda && <span className="jkl-c-error">{errors.azienda}</span>}
              </div>
            )}
            <div className="jkl-c-field">
              <label className="jkl-c-label">{t('contact.label_message')}</label>
              <textarea className={"jkl-c-input jkl-c-textarea"+(errors.messaggio?' error':'')} value={messaggio} onChange={e=>setMessaggio(e.target.value)} placeholder={t('contact.ph_message')} />
              {errors.messaggio && <span className="jkl-c-error">{errors.messaggio}</span>}
            </div>
            {errors.general && <span className="jkl-c-error" style={{textAlign:'center'}}>{errors.general}</span>}
            <button className="jkl-c-btn" onClick={handleSubmit} disabled={sending}>
              {sending ? t('contact.sending') : t('contact.submit')}
            </button>
          </div>
        )}

        <div className="jkl-c-footer">
          <div>{SVG_LOGO}</div>
          <p className="jkl-c-footer-copy">&copy; 2026 JKL &mdash; joinjkl.com</p>
        </div>
      </div>
    </div>
  );
}
